import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { TableData } from '@/components/Table/types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { Button, ExportTableButton, Table } from '@/components';
import styles from './DocumentsHistoryTable.module.scss';
import { getTableColumns } from './tableColumns';
import DocumentsHistoryFilters from './DocumentsHistoryFilters';
import { tableFilters } from './tableFilters';
import { TableFilters } from './TableFiltersType';
import { DocumentsHistoryListInfo } from '../../types';
import { columnsToExport } from '../../columnsToExport';

type DocumentsHistoryTableProps = {
  isLoading?: boolean;
  data: DocumentsHistoryListInfo[];
  filters: TableFilters;
  setFilters: (filters: TableFilters) => void;
  onSearch: () => void;
};

const FILE_NAME = 'Documents-Montecon';

const DocumentsHistoryTable: FC<DocumentsHistoryTableProps> = ({
  isLoading,
  data = [],
  filters,
  setFilters,
  onSearch,
}) => {
  const { t } = useTranslation('exchangesHeaders');
  const submitButtonText = t('submitButton');
  const columns = getTableColumns(t);

  const handleSearchClick = () => {
    onSearch();
  };

  return (
    <div className={styles.ExchangesTable}>
      <header className={styles.header}>
        <div className={styles.filtersContainer}>
          <DocumentsHistoryFilters filters={filters} setFilters={setFilters} />
        </div>

        <div className={styles.containerRigth}>
          <Button
            type="submit"
            className={styles.submitButton}
            onClick={handleSearchClick}
            disabled={isLoading}
          >
            <FontAwesomeIcon icon={faMagnifyingGlass} className={styles.icon} />
            {submitButtonText}
          </Button>
        </div>
        <div className={styles.containerExport}>
          <ExportTableButton
            data={data as unknown as TableData}
            columnsToExport={columnsToExport}
            fileName={FILE_NAME}
          />
        </div>
      </header>
      <div className={styles.tableContainer}>
        <Table
          columns={columns}
          data={data as unknown as TableData}
          isLoading={isLoading}
          className={styles.table}
          filterDisplay="menu"
          filters={tableFilters}
        />
      </div>
    </div>
  );
};

export default DocumentsHistoryTable;
